var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 35,
    rx: 7.5,
    stroke: "#398D94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 20.1667V13.5M19.9987 20.1667C19.5319 20.1667 18.6597 18.8371 18.332 18.5M19.9987 20.1667C20.4655 20.1667 21.3377 18.8371 21.6654 18.5",
    stroke: "#398D94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3346 21.5C25.3346 23.1547 24.9893 23.5 23.3346 23.5H16.668C15.0133 23.5 14.668 23.1547 14.668 21.5",
    stroke: "#398D94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGreen);
export default __webpack_public_path__ + "static/media/download-green.bb212f7c.svg";
export { ForwardRef as ReactComponent };